import { Box, Button, Icon, Image } from '@chakra-ui/react'
import React from 'react'
import { FaPlay } from 'react-icons/fa'
import { useMusicPlayer } from '../../context/MusicPlayerContext';
import { BeatIcon } from '../../tools/animatedIcons';

export default function TrackImage({item}) {

    const { playTrack, isPlaying, currentTrack } = useMusicPlayer();

  return (
    <Box
    gridColumn="1/2"
    gridRow="1/4"
    alignSelf="center"
    position="relative" // Enable relative positioning for the icon overlay
    transition="transform 0.3s ease-in-out"
    _hover={{ transform: "scale(1.1)" }}
>
    <Image
        src={item.image_url}
        alt={item.track_name}
        borderRadius="lg"
        width={{ base: "4rem", md: "4rem" }}
    />

    {/* Play Icon, initially hidden and visible on hover */}
    <Box
        position="absolute"
        as={Button}
        bg="transparent"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)" // Center the icon
        opacity={isPlaying && currentTrack.name === item.track_name ? "1":"0.5"} // Initially hidden
        transition="opacity 0.3s ease-in-out"
        isDisabled={item.track_url === "" && item.preview_url === ""}
        onClick={() =>  playTrack({
            name: item.track_name,
            artist: item.artist_name,
            image: item.image_url,
            url: item.preview_url ? item.preview_url : item.track_url,
            track_id: item.track_id,
            artist_id: item.publisher.id
        })}
        _hover={{ opacity: 1 }} // Show icon on hover
    >
        {isPlaying && currentTrack.name === item.track_name ? <BeatIcon/> : <Icon as={FaPlay} boxSize={6} color="white" /> }
      
    </Box>
</Box>
  )
}
